import { ClassifySelectionResult } from "../document-text-select/document-text-select.models";

// This is used to bridge between the Pdf Document Preview and the AI Document Preview component and
// still reuse the document text select service that has an embedded dialog pop.
export class DocumentPreviewComponent {

    constructor() {
        if (this.constructor == DocumentPreviewComponent) {
            throw new Error("Abstract classes can't be instantiated.");
        }
    }

    openClassifyPdfFees(passedInData?: ClassifySelectionResult[]) {
        throw new Error("Method needs to be implemented in the concrete class.");
    }
}
